var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm._.block,on:{"click":_vm.handleCertClick}},[_c('div',{class:_vm._.label},[_vm._v("商家资质")]),_c('img',{class:_vm._.arrow,attrs:{"src":require("./images/箭头_左_灰.png")}})])}
var staticRenderFns = []

export { render, staticRenderFns }